var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5865 3.16669H10.4132C5.55984 3.16669 2.6665 6.06002 2.6665 10.9134V22.0734C2.6665 26.94 5.55984 29.8334 10.4132 29.8334H21.5732C26.4265 29.8334 29.3198 26.94 29.3198 22.0867V10.9134C29.3332 6.06002 26.4398 3.16669 21.5865 3.16669ZM19.5465 18.8067L17.8398 19.7934L16.1332 20.78C13.9332 22.0467 12.1332 21.0067 12.1332 18.4734V16.5V14.5267C12.1332 11.98 13.9332 10.9534 16.1332 12.22L17.8398 13.2067L19.5465 14.1934C21.7465 15.46 21.7465 17.54 19.5465 18.8067Z",
    fill: "#908880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSquare);
export default __webpack_public_path__ + "static/media/video-square.80cba0f90cded20e88e4df3ef3246a2d.svg";
export { ForwardRef as ReactComponent };